export var ActionRunEnv;
(function (ActionRunEnv) {
    // 动作编排中
    ActionRunEnv["flowAction"] = "flowAction";
})(ActionRunEnv || (ActionRunEnv = {}));
